import React, { useContext, useState } from 'react'
import Draggable from 'react-draggable'

import { AppStateContext } from '../AppStateContext'
import Panel from '../../../elem/panel/Panel'
import WellDetailPanelHeader from './WellDetailPanelHeader'
import DataContextProvider from './DataContext'
import DetailTabs from './DetailTabs'
import WellDetails from './WellDetails'
import ScreenDetails from './ScreenDetailList'
import SampleDetails from './SampleDetailList'
import MITDetails from './MITDetailList'
import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import PressureDetail from './PressureDetailList'
import DetailChart from './chart/DetailChart'
import ExpandableDetailChart from './ExpandableDetailChart'

const Detail = () => {
    const { detailState } = useContext(AppStateContext)
    const [isDetailMenuExpanded, setIsDetailMenuExpanded] = useState(false)
    const visible = detailState.well.visible

    return (
        <DataContextProvider>
            <ExpandableDetailChart visible={visible} />
            <Draggable
                bounds="parent"
                handle=".wellDetailPanelHeader"
                positionOffset={{ x: '.75rem', y: '.75rem' }}
                disabled={isDetailMenuExpanded}
                position={isDetailMenuExpanded ? { x: 0, y: 0 } : null}
            >
                <div
                    className={`column is-4-desktop is-half-tablet is-full-mobile detailPanelWrapper ${
                        !visible ? 'is-invisible' : ''
                    } ${isDetailMenuExpanded ? 'transform-none' : ''}`}
                    style={
                        !isDetailMenuExpanded
                            ? { left: '40%', top: '15px' }
                            : {}
                    }
                >
                    <Panel panelClassConfig={panelClassConfig()}>
                        <WellDetailPanelHeader
                            setIsDetailMenuExpanded={setIsDetailMenuExpanded}
                        />
                        <div className="wellDetailWrapper">
                            <DetailChart />
                            <DetailTabs />
                            <WellDetails />
                            <ScreenDetails />
                            <SampleDetails />
                            <PressureDetail />
                            <MITDetails />
                        </div>
                    </Panel>
                </div>
            </Draggable>
        </DataContextProvider>
    )
}

export default Detail
